var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('NavBar'),_c('v-container',[_c('MainMenu'),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('notification-container',{staticClass:"mr-5 ml-5"})],1)],1),_c('account')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }